import api from "../axios";

export const ClientBookTicket = (data) => api.post("ticket/bookticket", data);
export const ClientTicketStatusApi = (data) => api.get(`ticket/${data}`, data);
export const UpdateTicketStatusPayment = (data) =>
  api.patch("ticket/update-payment-status", data);
export const SendTicketEmail = (ticketid) =>
  api.post(`ticket/${ticketid}/send-email`);
export const vendorUpdateTicketStatus = (data) =>
  api.patch("update-ticket-status", data); // Wait, this URL seems odd for "ticket", but function name...
